import { Controller, useFormContext } from 'react-hook-form';

import { ErrorMessage, Label } from 'components/form/aksel';
import { MarkdownEditor } from 'web/components/MarkdownEditor';

export default function MarkdownField({ name, label = null }) {
	const { control } = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			render={({ field: { onChange, value }, fieldState: { error } }) => (
				<div>
					{/* Use a paragraph because the editor has no input ID for a label. */}
					{label && (
						<Label as="p" size="small">
							{label}
						</Label>
					)}

					<MarkdownEditor value={value} onChange={onChange} />

					{error?.message && (
						<ErrorMessage size="small" showIcon>
							{error.message}
						</ErrorMessage>
					)}
				</div>
			)}
		/>
	);
}
